import React from 'react'
import file from '../../../../Global/assets/SootExperiment.mp4'

const SootCarbon = () => {
    return (
        <>
            <div id="ExperimentsB" style={{ height: '110vh' }}>
                <div style={{ width: '80%', height: '50%' }}>
                    <video src={file} width='100%' height='100%' controls></video>
                </div>
                <div style={{width:'80%', height:'30vh', color:'#fff'}}>
                    <h1>Difference Between the Soot Produced on Burning the Unsaturated and Saturated Carbon Conmpound.</h1><br />
                    <h6>Observations : </h6><br />
                    <h6>1. The Unsaturated Carbon Compund used here was Camphor.</h6>
                    <h6>2. The Saturated Carbon Compound used here was Ghee.</h6>
                    <h6>3. It is seen that the Unsaturated Carbon Compund ( Camphor ) produced a lot more ammounnt of soot than the Saturated Carbon Compund ( Ghee ).</h6>
                </div>
            </div>
        </>
    )
}

export { SootCarbon }